<form #form="ngForm" [formGroup]="filterForm">
    <div class="row mt-2">
        @for (field of filterFieldsJson; track field) {
            @switch (field.type) {
                @case (fieldTypeEnum.SINGLE_SELECT) {
                    <div [ngClass]="field.positionClass">
                        <div class="form-group mat-form-field-width">
                            <mat-form-field appearance="outline">
                                <mat-select
                                    [placeholder]="field.placeholder ?? 'Enter' + field.label"
                                    [compareWith]="utils.codeComparer"
                                    [formControlName]="field.formControl"
                                >
                                    @for (list of field.dropdownOption; track list) {
                                        <mat-option [value]="list.code">
                                            {{ list.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                }
                @case (fieldTypeEnum.MULTI_SELECT) {
                    <div [ngClass]="field.positionClass">
                        <div class="form-group mat-form-field-width">
                            <mat-form-field appearance="outline">
                                <mat-select
                                    [placeholder]="field.placeholder ?? 'Enter ' + field.label"
                                    [compareWith]="utils.idComparer"
                                    [formControlName]="field.formControl"
                                    multiple
                                >
                                    @for (list of field.dropdownOption; track list) {
                                        <mat-option [value]="list.code">
                                            {{ list.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                }
                @case (fieldTypeEnum.MULTI_SELECT_WITH_COMMA_SEPARATED) {
                    <div [ngClass]="field.positionClass">
                        <div class="form-group mat-form-field-width">
                            <mat-form-field appearance="outline">
                                <mat-select
                                    [placeholder]="field.placeholder ?? 'Enter ' + field.label"
                                    [compareWith]="utils.idComparer"
                                    [formControlName]="field.formControl"
                                    multiple
                                >
                                    @for (list of field.dropdownOption; track list) {
                                        <mat-option [value]="list.code">
                                            {{ list.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                }
                @case (fieldTypeEnum.DATE_TIME_RANGE_PICKER) {
                    <div [ngClass]="field.positionClass">
                        <div class="form-group mat-form-field-width">
                            <mat-form-field appearance="outline">
                                <mat-datetimepicker-toggle [for]="datetimePickerStart" matSuffix></mat-datetimepicker-toggle>
                                <mat-datetimepicker
                                    #datetimePickerStart
                                    type="datetime"
                                    openOnFocus:true
                                    timeInterval:5
                                    mode="portrait"
                                ></mat-datetimepicker>
                                <input
                                    matInput
                                    [formControlName]="field.formControl"
                                    [matDatetimepicker]="datetimePickerStart"
                                    [placeholder]="field.placeholder ?? 'Enter ' + field.label"
                                    autocomplete="false"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                }
            }
        }
        <!-- @if (hasParameterDropdown) {
            <div class="col-6 col-xl-4">
                <div class="form-group mat-form-field-width">
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Select Parameter" [compareWith]="utils.idComparer" formControlName="parameterId">
                            @for (list of parameterIdList; track list) {
                                <mat-option [value]="list">
                                    {{ list }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        }
        <div class="col-6 col-xl-4">
            <div class="form-group mat-form-field-width">
                <mat-form-field appearance="outline">
                    <mat-select placeholder="SELECT FIELD" [compareWith]="utils.idComparer" formControlName="selectColumn" multiple>
                        @for (list of columnFieldList; track list) {
                            <mat-option class="text-capitalize" [value]="list">
                                {{ list }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-6 col-xl-4">
            <div class="form-group mat-form-field-width">
                <mat-form-field appearance="outline">
                    <mat-datetimepicker-toggle [for]="datetimePickerStart" matSuffix></mat-datetimepicker-toggle>
                    <mat-datetimepicker
                        #datetimePickerStart
                        type="datetime"
                        openOnFocus:true
                        timeInterval:5
                        mode="portrait"
                    ></mat-datetimepicker>
                    <input
                        matInput
                        formControlName="startDate"
                        [matDatetimepicker]="datetimePickerStart"
                        placeholder="Choose a start date"
                        autocomplete="false"
                    />
                </mat-form-field>
            </div>
        </div>
        <div class="col-6 col-xl-4">
            <div class="form-group mat-form-field-width">
                <mat-form-field appearance="outline">
                    <mat-datetimepicker-toggle [for]="datetimePicker" matSuffix></mat-datetimepicker-toggle>
                    <mat-datetimepicker
                        #datetimePicker
                        type="datetime"
                        openOnFocus:true
                        timeInterval:5
                        mode="portrait"
                    ></mat-datetimepicker>
                    <input
                        matInput
                        formControlName="endDate"
                        [matDatetimepicker]="datetimePicker"
                        placeholder="Choose a end date"
                        autocomplete="false"
                    />
                </mat-form-field>
            </div>
        </div>
        @if (!hasParameterDropdown) {
            <div class="col-6 col-xl-4">
                <div class="form-group mat-form-field-width">
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="timeInterval" [compareWith]="utils.idComparer" placeholder="Select Interval">
                            @for (intervalTime of intervals; track intervalTime) {
                                <mat-option [value]="intervalTime">
                                    {{ intervalTime.value }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        } -->
    </div>
</form>
<div class="row text-end">
    <div class="col-12">
        @for (btn of filterBtnConfiguration; track btn) {
            <button
                [ngClass]="btn.buttonClass"
                mat-flat-button
                [color]="btn.buttonColor"
                (click)="handleFilterBtn(btn.buttonActionEmitEvent)"
                [disabled]="btn.isButtonDisable"
            >
                {{ btn.buttonName }}
            </button>
        }
    </div>
</div>
